export default __webpack_public_path__ + "static/media/ge2.e866a488.jpg";